import i18n from 'i18next';

import { STRIPE_SERVER } from '~/config/global.config';

/**
 * Demande l'envoi de l'email de réinitialisation via le serveur backend
 * (lien généré par l'Admin SDK + envoi Resend depuis noreply@unboared.com).
 * Remplace sendPasswordResetEmail() du SDK client : le template email
 * Firebase du projet est gelé par Google (wiki gotcha #128) et l'email
 * partait en spam. Le serveur répond toujours succès, que l'email existe
 * ou non (anti-énumération).
 */
export const requestPasswordReset = async (email: string): Promise<void> => {
    const response = await fetch(`${STRIPE_SERVER}/auth/send-reset`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, lang: i18n.language }),
    });
    if (!response.ok) {
        throw new Error(`send-reset failed (${response.status})`);
    }
};
